export default {
    props: {
        filterableExtra: {
            type: Boolean,
            kComposite: 'filterable.extra'
        }, 
        filterableMessagesAnd: {
            type: String,
            kComposite: 'filterable.messages.and'
        }, 
        filterableMessagesClear: {
            type: String,
            kComposite: 'filterable.messages.clear'
        }, 
        filterableMessagesFilter: {
            type: String,
            kComposite: 'filterable.messages.filter'
        }, 
        filterableMessagesInfo: {
            type: String,
            kComposite: 'filterable.messages.info'
        }, 
        filterableMessagesIsFalse: {
            type: String,
            kComposite: 'filterable.messages.isFalse'
        }, 
        filterableMessagesIsTrue: {
            type: String,
            kComposite: 'filterable.messages.isTrue'
        }, 
        filterableMessagesOr: {
            type: String,
            kComposite: 'filterable.messages.or'
        }, 
        filterableMessagesSearch: {
            type: String,
            kComposite: 'filterable.messages.search'
        }, 
        filterableMessagesSelectValue: {
            type: String,
            kComposite: 'filterable.messages.selectValue'
        }, 
        filterableMessagesCancel: {
            type: String,
            kComposite: 'filterable.messages.cancel'
        }, 
        filterableMessagesSelectedItemsFormat: {
            type: String,
            kComposite: 'filterable.messages.selectedItemsFormat'
        }, 
        filterableMessagesOperator: {
            type: String,
            kComposite: 'filterable.messages.operator'
        }, 
        filterableMessagesValue: {
            type: String,
            kComposite: 'filterable.messages.value'
        }, 
        filterableMessagesCheckAll: {
            type: String,
            kComposite: 'filterable.messages.checkAll'
        }, 
        filterableMode: {
            type: String,
            kComposite: 'filterable.mode'
        }, 
        filterableOperatorsStringEq: {
            type: String,
            kComposite: 'filterable.operators.string.eq'
        }, 
        filterableOperatorsStringNeq: {
            type: String,
            kComposite: 'filterable.operators.string.neq'
        }, 
        filterableOperatorsStringIsnull: {
            type: String,
            kComposite: 'filterable.operators.string.isnull'
        }, 
        filterableOperatorsStringIsnotnull: {
            type: String,
            kComposite: 'filterable.operators.string.isnotnull'
        }, 
        filterableOperatorsStringIsempty: {
            type: String,
            kComposite: 'filterable.operators.string.isempty'
        }, 
        filterableOperatorsStringIsnotempty: {
            type: String,
            kComposite: 'filterable.operators.string.isnotempty'
        }, 
        filterableOperatorsStringStartswith: {
            type: String,
            kComposite: 'filterable.operators.string.startswith'
        }, 
        filterableOperatorsStringContains: {
            type: String,
            kComposite: 'filterable.operators.string.contains'
        }, 
        filterableOperatorsStringDoesnotcontain: {
            type: String,
            kComposite: 'filterable.operators.string.doesnotcontain'
        }, 
        filterableOperatorsStringEndswith: {
            type: String,
            kComposite: 'filterable.operators.string.endswith'
        }, 
        filterableOperatorsNumberEq: {
            type: String,
            kComposite: 'filterable.operators.number.eq'
        }, 
        filterableOperatorsNumberNeq: {
            type: String,
            kComposite: 'filterable.operators.number.neq'
        }, 
        filterableOperatorsNumberIsnull: {
            type: String,
            kComposite: 'filterable.operators.number.isnull'
        }, 
        filterableOperatorsNumberIsnotnull: {
            type: String,
            kComposite: 'filterable.operators.number.isnotnull'
        }, 
        filterableOperatorsNumberGte: {
            type: String,
            kComposite: 'filterable.operators.number.gte'
        }, 
        filterableOperatorsNumberGt: {
            type: String,
            kComposite: 'filterable.operators.number.gt'
        }, 
        filterableOperatorsNumberLte: {
            type: String,
            kComposite: 'filterable.operators.number.lte'
        }, 
        filterableOperatorsNumberLt: {
            type: String,
            kComposite: 'filterable.operators.number.lt'
        }, 
        filterableOperatorsDateEq: {
            type: String,
            kComposite: 'filterable.operators.date.eq'
        }, 
        filterableOperatorsDateNeq: {
            type: String,
            kComposite: 'filterable.operators.date.neq'
        }, 
        filterableOperatorsDateIsnull: {
            type: String,
            kComposite: 'filterable.operators.date.isnull'
        }, 
        filterableOperatorsDateIsnotnull: {
            type: String,
            kComposite: 'filterable.operators.date.isnotnull'
        }, 
        filterableOperatorsDateGte: {
            type: String,
            kComposite: 'filterable.operators.date.gte'
        }, 
        filterableOperatorsDateGt: {
            type: String,
            kComposite: 'filterable.operators.date.gt'
        }, 
        filterableOperatorsDateLte: {
            type: String,
            kComposite: 'filterable.operators.date.lte'
        }, 
        filterableOperatorsDateLt: {
            type: String,
            kComposite: 'filterable.operators.date.lt'
        }, 
        filterableOperatorsEnumsEq: {
            type: String,
            kComposite: 'filterable.operators.enums.eq'
        }, 
        filterableOperatorsEnumsNeq: {
            type: String,
            kComposite: 'filterable.operators.enums.neq'
        }, 
        filterableOperatorsEnumsIsnull: {
            type: String,
            kComposite: 'filterable.operators.enums.isnull'
        }, 
        filterableOperatorsEnumsIsnotnull: {
            type: String,
            kComposite: 'filterable.operators.enums.isnotnull'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/Filterable.js